/* ============================================================
   STICKEREI-KARTE · Live-Vorschau im Produktbild (Galerie)
   Zeigt in einem Overlay ueber Dawns Bildergalerie eine
   hochskalierte Kopie der jeweiligen Positions-Vorschau (Vorne/
   Hinten/Links/Rechts - hier ueberall reiner Text, kein Logo).
   Kopiert statt verschiebt, damit die kleinen Vorschauen in der
   Karte selbst unveraendert stehen bleiben. Fasst keine
   Dawn-Kerndatei an - haengt sich nur nachtraeglich per
   JavaScript ein. Baugleich mit wl-galerie-vorschau.js.
   ============================================================ */
(function () {
  var REIHENFOLGE = ['vorne', 'hinten', 'links', 'rechts'];

  function init() {
    var karte = document.getElementById('stickerei-karte');
    if (!karte) return;

    var sectionId = karte.getAttribute('data-section-id');
    var gallery = sectionId && document.getElementById('MediaGallery-' + sectionId);
    if (!gallery) return;

    var list = gallery.querySelector('ul.product__media-list');
    if (!list) return;

    if (getComputedStyle(list).position === 'static') {
      list.style.position = 'relative';
    }

    var cfg = {};
    try { cfg = JSON.parse(karte.getAttribute('data-config')) || {}; } catch (e) { cfg = {}; }
    var flaechen = cfg.flaechen || {};

    /* offen: aktueller Sichtbarkeits-Zustand. manuellGeschlossen: hat
       der Kunde den Knopf "Live-Vorschau beenden" schon mal angetippt?
       Getrennt von "offen" selbst, weil sonst der ALLERERSTE sync()-
       Aufruf beim Laden der Seite (noch kein Text/Logo vorhanden, also
       offen=false) das "einmalig automatisch oeffnen" fuer immer
       verbraucht haette - dieser Bug sorgte dafuer, dass sich die
       Vorschau nie von selbst oeffnete, sondern immer der Klick auf
       "Live-Vorschau ansehen" noetig war. */
    var offen = false;
    var manuellGeschlossen = false;
    var aktivTab = null;

    /* ---------- Knopf im Produktbild ---------- */
    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'skgv-knopf';
    knopf.innerHTML = '<span aria-hidden="true">🧵</span> Live-Vorschau ansehen';
    list.appendChild(knopf);

    /* ---------- Overlay-Panel ----------
       Reihenfolge von oben nach unten: Buehne (Bild) nimmt den
       meisten Platz ein, direkt darunter die Kopfleiste, dann die
       Reiter, ganz unten der Hinweistext. */
    var panel = document.createElement('div');
    panel.className = 'skgv-panel';
    panel.hidden = true;

    var buehne = document.createElement('div');
    buehne.className = 'skgv-buehne';
    panel.appendChild(buehne);

    var kopf = document.createElement('div');
    kopf.className = 'skgv-kopfleiste';
    kopf.innerHTML =
      '<span class="skgv-marke">🧵 Live-Vorschau</span>' +
      '<button type="button" class="skgv-schliessen">Live-Vorschau beenden <span aria-hidden="true">×</span></button>';
    panel.appendChild(kopf);

    var tabsRow = document.createElement('div');
    tabsRow.className = 'skgv-tabs';
    tabsRow.hidden = true;
    panel.appendChild(tabsRow);

    var hinweis = document.createElement('p');
    hinweis.className = 'skgv-hinweis';
    hinweis.textContent = 'Die Vorschau dient der Orientierung, Position und Größe können leicht abweichen.';
    panel.appendChild(hinweis);

    list.appendChild(panel);

    /* ---------- Inhalt je Position ---------- */
    function hatInhalt(p) {
      var block = document.querySelector('.sk-block[data-position="' + p + '"]');
      if (!block) return false;
      var ta = block.querySelector('.sk-textarea');
      return Boolean(ta && ta.value && ta.value.trim());
    }

    function quelle(p) {
      var block = document.querySelector('.sk-block[data-position="' + p + '"]');
      return block && block.querySelector('.sk-prev');
    }

    function label(p) {
      return (flaechen[p] && flaechen[p].kurz) || p;
    }

    /* Kopiert das Quellelement und skaliert die Kopie per CSS-Transform
       auf die verfuegbare Flaeche hoch. So bleiben alle intern in px
       berechneten Werte (Schriftgroesse, Stickflaeche) im richtigen
       Verhaeltnis zueinander, ohne dass wir deren Berechnung hier
       nachbauen muessen. */
    function mirrorInto(source, container) {
      container.innerHTML = '';
      if (!source) return;
      var natBreite = source.offsetWidth;
      var natHoehe = source.offsetHeight;
      if (!natBreite || !natHoehe) return;

      var clone = source.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function (n) { n.removeAttribute('id'); });
      clone.style.width = natBreite + 'px';
      clone.style.height = natHoehe + 'px';
      clone.style.transformOrigin = 'top left';

      var aussen = document.createElement('div');
      aussen.className = 'skgv-scaler';
      aussen.appendChild(clone);
      container.appendChild(aussen);

      var verfuegbarB = container.clientWidth;
      var verfuegbarH = container.clientHeight;
      if (!verfuegbarB || !verfuegbarH) return;
      /* An beide Richtungen anpassen, nicht nur an die Breite - sonst
         ragt die Vorschau bei knapper Hoehe (z.B. auf dem Handy) unten
         heraus und die Buehne faengt an zu scrollen. */
      var faktor = Math.min(verfuegbarB / natBreite, verfuegbarH / natHoehe);
      clone.style.transform = 'scale(' + faktor + ')';
      aussen.style.width = (natBreite * faktor) + 'px';
      aussen.style.height = (natHoehe * faktor) + 'px';

      /* Der geklonte Ziehgriff (cloneNode kopiert ihn mit, aber ohne
         Event-Listener) wird entfernt und durch stickerei-karte.js
         frisch verdrahtet - so laesst sich die Schriftgroesse auch
         direkt in dieser grossen Vorschau ziehen, nicht nur in der
         kleinen Karte. */
      clone.querySelectorAll('.sk-resize-handle').forEach(function (n) { n.remove(); });
      if (karte.lcGriffFuerKlon) karte.lcGriffFuerKlon(clone, aktivTab);
    }

    function sync() {
      var vorhanden = REIHENFOLGE.filter(hatInhalt);

      if (!manuellGeschlossen && vorhanden.length > 0) offen = true;
      if (vorhanden.length === 0) offen = false;
      knopf.hidden = offen || vorhanden.length === 0;
      panel.hidden = !offen;

      /* Dawns eigene Galerie-Bildlaufleiste (Kappenfarben-Fotos) blitzt
         sonst unten durch unser Overlay durch - waehrend die Vorschau
         offen ist, blenden wir sie aus. */
      list.style.overflow = offen ? 'hidden' : '';

      if (!offen) return;

      if (!aktivTab || vorhanden.indexOf(aktivTab) === -1) {
        aktivTab = vorhanden[0];
      }

      tabsRow.hidden = vorhanden.length < 2;
      tabsRow.innerHTML = '';
      vorhanden.forEach(function (p) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'skgv-tab' + (p === aktivTab ? ' ist-aktiv' : '');
        btn.textContent = label(p);
        btn.addEventListener('click', function () { aktivTab = p; sync(); });
        tabsRow.appendChild(btn);
      });

      mirrorInto(quelle(aktivTab), buehne);
    }

    knopf.addEventListener('click', function () { offen = true; manuellGeschlossen = false; sync(); });
    kopf.querySelector('.skgv-schliessen').addEventListener('click', function () { offen = false; manuellGeschlossen = true; sync(); });

    /* Ein einziger, verzoegerter Sync-Aufruf reicht: er laeuft in der
       Bubble-Phase nach dem jeweiligen Feld-eigenen Listener, der
       stickerei-karte.js bereits neu gezeichnet hat.
       'lc-alles' zusaetzlich zu den nativen Ereignissen - siehe
       Kommentar zum baugleichen Fix in wunschlogo-karte.js/
       wl-galerie-vorschau.js. */
    ['input', 'change', 'click', 'lc-alles'].forEach(function (art) {
      karte.addEventListener(art, function () {
        requestAnimationFrame(sync);
      });
    });

    /* Fehlte bisher (22. September 2026): der Farbwechsel (Variantenauswahl)
       liegt AUSSERHALB von #stickerei-karte (in buy-buttons.liquid), der
       obige karte.addEventListener bekommt ihn also nie mit - die schon
       GEOEFFNETE Live-Vorschau zeigte dadurch weiter die alte Farbe, bis
       man sie zu- und wieder aufgemacht hat. requestAnimationFrame sorgt
       dafuer, dass stickerei-karte.js CFG.farbeAktuell und die kleine
       Vorschau in der Karte zuerst fertig aktualisiert, bevor hier neu
       geklont wird. Baugleich mit wl-galerie-vorschau.js. */
    document.addEventListener('change', function (e) {
      if (!e.target.closest('variant-selects')) return;
      requestAnimationFrame(sync);
    });

    /* Bei Drehung des Handys oder wenn die mobile Adressleiste ein-/
       ausblendet aendert sich die verfuegbare Hoehe - dann die
       Vorschau neu einpassen, damit sie nicht abgeschnitten wirkt. */
    window.addEventListener('resize', function () {
      if (offen) mirrorInto(quelle(aktivTab), buehne);
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();